
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.451 17.83a.752.752 0 00.26 0 7 7 0 004.39-6.57 7.19 7.19 0 00-7.1-7.14 7.19 7.19 0 00-7.1 7.1 7 7 0 004.39 6.57.752.752 0 00.26 0l4.9.04zm-3.1-1.47a.24.24 0 01-.24-.2l-.51-2.8a.22.22 0 01.07-.22.25.25 0 01.23-.07c.723.18 1.478.18 2.2 0a.25.25 0 01.23.07.22.22 0 01.07.22l-.51 2.8a.24.24 0 01-.24.2h-1.3zm.65-10.77a5.78 5.78 0 015.63 5.63 5.54 5.54 0 01-2.82 4.9.26.26 0 01-.27 0 .24.24 0 01-.1-.25l.73-4a.74.74 0 00-.28-.72.76.76 0 00-.77-.07l-.7.35a3.16 3.16 0 01-2.84 0l-.7-.35a.76.76 0 00-.77.07.74.74 0 00-.28.72l.73 4a.24.24 0 01-.1.25.26.26 0 01-.27 0 5.54 5.54 0 01-2.82-4.9 5.78 5.78 0 015.63-5.63zM11.999 3.87a1 1 0 001-1V1a1 1 0 10-2 0v1.89a1 1 0 001 .98zM3.47 11.71a1 1 0 000-2H1.22a1 1 0 100 2h2.25z","fill":"#161616","fill-opacity":".88"}}),_c('path',{attrs:{"d":"M4.94 6a1 1 0 001.39 0 1 1 0 000-1.39L4.46 2.78a1 1 0 00-1.39 1.39L4.94 6zM19.552 10.73a1 1 0 001 1h2.25a1 1 0 100-2h-2.27a1 1 0 00-.98 1zM18.372 6.32a1 1 0 00.69-.32l1.87-1.87a1 1 0 10-1.39-1.39l-1.87 1.91a1 1 0 000 1.39 1 1 0 00.7.28zM15.43 19.55a1 1 0 00-1-1H9.55a1 1 0 000 2h4.9a1 1 0 00.98-1zM15.43 22a1 1 0 00-1-1H9.55a1 1 0 000 2h1.25a.25.25 0 01.24.2 1 1 0 001.92 0 .25.25 0 01.24-.2h1.25a1 1 0 00.98-1z","fill":"#161616","fill-opacity":".88"}})])
          )
        }
      }
    